// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comparison-lab-container {
  width: 100%;
  max-width: 389px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.comparison-lab-container h2,
.comparison-lab-container p {
  font-family: Figtree;
}
.comparison-lab-container h2 {
  font-weight: bold;
  font-size: 23px;
  color: var(--sebrae-blue-6);
}
.comparison-lab-container svg {
  cursor: pointer;
  margin-left: -12px;
}
@media (max-width: 1200px) {
  .comparison-lab-container {
    max-width: 100%;
    align-items: center;
  }
}
@media screen and (max-width: 992px) {
  .comparison-lab-container.no-mobile {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/comparison-lab/access/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EAEA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;AAEE;;EAEE,oBAAA;AAAJ;AAGE;EACE,iBAAA;EACA,eAAA;EACA,2BAAA;AADJ;AAIE;EACE,eAAA;EACA,kBAAA;AAFJ;AAKE;EAxBF;IAyBI,eAAA;IACA,mBAAA;EAFF;AACF;AAIE;EACE;IACE,aAAA;EAFJ;AACF","sourcesContent":[".comparison-lab-container {\n  width: 100%;\n  max-width: 389px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  h2,\n  p {\n    font-family: Figtree;\n  }\n\n  h2 {\n    font-weight: bold;\n    font-size: 23px;\n    color: var(--sebrae-blue-6);\n  }\n\n  svg {\n    cursor: pointer;\n    margin-left: -12px;\n  }\n\n  @media (max-width: 1200px) {\n    max-width: 100%;\n    align-items: center;\n  }\n\n  @media screen and (max-width: 992px) {\n    &.no-mobile {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
